import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";

export const Isotipo = styled((props) => {
  const { variant, ...other } = props;

  const color = variant === "light" ? "#ffffff" : "#85c6f3";

  return (
    <svg
      width="22"
      height="24"
      viewBox="0 0 22 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.8786 16.94C19.9073 15.3448 21.5373 12.3808 21.5373 9.3036C21.5373 4.1578 17.7514 0 10.5268 0H0V3.74614C0 6.6072 2.37667 8.93311 5.30019 8.93311L11.8728 7.65695L6.05736 7.8422L5.46845 5.55746C5.38432 5.15609 5.75239 4.79588 6.16252 4.86792L15.8059 6.6175C16.3107 6.71012 16.4684 7.32762 16.0688 7.64666L8.11855 13.6261C7.76099 13.8937 7.22466 13.7084 7.13002 13.2762L6.68834 11.2487L5.19503 11.2384C2.32409 11.2384 0 13.5129 0 16.3225V24H5.30019V18.5557H10.0325C10.7476 18.5557 11.3996 18.4837 12.1147 18.3705L15.9006 24H22L16.8786 16.94Z"
        fill="#40C1AC"
      />
    </svg>
  );
})``;

Isotipo.defaultProps = {
  variant: "primary",
};

Isotipo.propTypes = {
  variant: PropTypes.oneOf(["light", "primary"]),
};
